import { useState } from "react";
import {
    Stack,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Typography,
    Button,
    Box,
} from "@mui/material";
import GeneralUtilityService from "services/GeneralUtilityService";

const MAX_CALL_HISTORY_LENGTH = 3;

export const PhoneCallStepper = ({ phoneCalls = [] }) => {
    const [showAll, setShowAll] = useState(false);

    if (phoneCalls.length === 0) {
        return (
            <Box
                width="100%"
                p={2}
                sx={{
                    borderRadius: 1,
                    bgcolor: "grey.100",
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    No calls yet.
                </Typography>
            </Box>
        );
    }

    // collapsed: last N; expanded: all
    const visibleCalls = showAll
        ? phoneCalls
        : phoneCalls.slice(-MAX_CALL_HISTORY_LENGTH);

    // number of hidden items when collapsed
    const hiddenCount = phoneCalls.length - visibleCalls.length;
    const toggleLabel = showAll
        ? "Show less"
        : `Show ${hiddenCount} more call${hiddenCount > 1 ? "s" : ""}`;

    // calculate the original index for numbering
    const startIndex = showAll ? 0 : phoneCalls.length - visibleCalls.length;

    return (
        <Stack
            sx={{
                width: "100%",
            }}
            alignItems="flex-end"
        >
            <Stepper
                sx={{
                    width: "100%",
                }}
                orientation="vertical"
                nonLinear
            >
                {visibleCalls.map((call, idxVis) => {
                    const idxOriginal = startIndex + idxVis;
                    const { recruiterName, recruiterEmail, formattedTime } =
                        GeneralUtilityService.getCallInfo(call);

                    return (
                        <Step
                            key={`${idxVis}-${call.created_at.timestamp}`}
                            active
                        >
                            <StepLabel icon={idxOriginal + 1}>
                                <Typography variant="subtitle1">
                                    {recruiterName}
                                </Typography>
                                <Typography variant="subtitle2">
                                    {recruiterEmail}
                                </Typography>
                            </StepLabel>
                            <StepContent>
                                <Typography variant="caption">
                                    {formattedTime}
                                </Typography>
                            </StepContent>
                        </Step>
                    );
                })}
            </Stepper>

            {Boolean(hiddenCount) && (
                <Button
                    onClick={() => setShowAll((v) => !v)}
                    size="small"
                    variant="text"
                    sx={{
                        fontSize: 13,
                        textTransform: "none",
                        mt: 2,
                    }}
                >
                    {toggleLabel}
                </Button>
            )}
        </Stack>
    );
};

export default PhoneCallStepper;
